package com.milta.core.network

/**
 * Exception thrown when the Milta API returns a non-2xx HTTP response.
 * Lives in core.network — do NOT duplicate in feature packages.
 */
class ApiException(val statusCode: Int, override val message: String) : Exception(message)
